import React from "react";
import { ArrowRight, Link as LinkIcon } from "lucide-react";
import { getRelatedSeoEntries } from "../../utils/seoRegistry";

interface SeoRelatedLinksProps {
  currentRoute: string;
  onNavigate: (path: string) => void;
  title?: string;
}

export function SeoRelatedLinks({ currentRoute, onNavigate, title = "Related Resources & Direct Search Directories" }: SeoRelatedLinksProps) {
  const relatedEntries = getRelatedSeoEntries(currentRoute, 6);

  if (!relatedEntries || relatedEntries.length === 0) return null;

  const handleLinkClick = (e: React.MouseEvent, path: string) => {
    e.preventDefault();
    onNavigate(path);
  };

  return (
    <section className="mt-12 pt-8 border-t border-slate-200">
      <div className="flex items-center gap-2 mb-4">
        <LinkIcon className="w-4 h-4 text-indigo-600" />
        <h3 className="text-sm font-bold text-slate-900 tracking-wide uppercase">{title}</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {relatedEntries.map((entry) => (
          <a
            key={entry.route}
            href={entry.route}
            onClick={(e) => handleLinkClick(e, entry.route)}
            className="p-3.5 rounded-xl border border-slate-200 bg-white hover:border-indigo-300 hover:shadow-sm transition group flex flex-col justify-between cursor-pointer"
          >
            <div>
              <span className="text-[10px] font-semibold text-indigo-600 uppercase tracking-wider mb-1 block">
                {entry.pageType.replace("-", " ")}
              </span>
              <h4 className="text-xs font-semibold text-slate-800 group-hover:text-indigo-600 transition line-clamp-2">
                {entry.h1 || entry.title}
              </h4>
            </div>
            <div className="flex items-center gap-1 text-[11px] font-medium text-slate-500 group-hover:text-indigo-600 mt-2">
              <span>View Resource</span>
              <ArrowRight className="w-3 h-3 group-hover:translate-x-0.5 transition-transform" />
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
